import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, IconButton } from '@mui/material';
import { css, styled as muiStyled } from '@mui/material/styles';
import React from 'react';

import {
  DesignToken,
  type DesignTokenSet,
} from '~/client/components/base/core';
import { useDesignTokens } from '~/client/hooks/use-design-tokens';

interface Props {
  className?: string;
  navColumnOpen: boolean;
  onToggle: () => void;
}

const NavigationToggleButtonImpl: React.FC<Props> = ({
  className,
  navColumnOpen,
  onToggle,
}) => {
  return (
    <Box className={className}>
      <IconButton onClick={onToggle} className="toggle-button">
        {navColumnOpen ? (
          <ChevronLeftIcon fontSize="small" />
        ) : (
          <ChevronRightIcon fontSize="small" />
        )}
      </IconButton>
    </Box>
  );
};

const StyledNavigationToggleButton = muiStyled(NavigationToggleButtonImpl, {
  shouldForwardProp: (prop) => prop !== 'tokens',
})<Props & { tokens?: DesignTokenSet }>(({ tokens }) => {
  const t = tokens ?? DesignToken;
  return css`
    position: absolute;
    top: 12px;
    right: 8px;
    z-index: 10;

    .toggle-button {
      width: 28px;
      height: 28px;
      flex-shrink: 0;
      background-color: color-mix(
        in srgb,
        var(--org-secondary-color, ${t.nav.itemTextOnDarkMuted}) 15%,
        transparent
      );
      color: var(--org-primary-contrast, ${t.nav.itemTextOnDark});

      &:hover {
        background-color: color-mix(
          in srgb,
          var(--org-secondary-color, ${t.nav.itemTextOnDarkMuted}) 25%,
          transparent
        );
      }
    }
  `;
});

export const NavigationToggleButton: React.FC<Props> = (props) => {
  const t = useDesignTokens();
  return <StyledNavigationToggleButton tokens={t} {...props} />;
};

export default NavigationToggleButton;
